module.exports = __webpack_public_path__ + "static/media/odonto_1.7a1f5f4a.jpg";